import { useEffect, useState } from 'react';
import { getTeamPermissions } from 'asset-actions-lib/api/manageAccess';
/**
 * Returns all teams that are assigned to @objectIdOrIds via marketing/asset-permissions/v1/teams service.
 * In case @objectIdOrIds has more than one object id, the API call won't run and the hook will return an empty array of team ids.
 */
export default function useFetchTeamPermissions({
  objectType,
  objectId
}) {
  const [state, setState] = useState({
    loading: true,
    teamIds: [],
    error: undefined
  });
  useEffect(() => {
    setState({
      loading: true,
      teamIds: [],
      error: undefined
    });
    getTeamPermissions({
      objectType,
      objectId
    }).then(teamIds => setState({
      loading: false,
      teamIds,
      error: undefined
    })).catch(error => setState({
      loading: false,
      teamIds: [],
      error
    }));
  }, [objectType, objectId]);
  return state;
}